import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { StorePreset, StorePresetService } from '../../services/store-preset.service';

@Component({
  selector: 'app-store-preset-dialog',
  templateUrl: './store-preset-dialog.component.html',
  styleUrl: './store-preset-dialog.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, DialogModule, ButtonModule, InputTextModule],
})
export class StorePresetDialogComponent {
  @Input() componentName = '';
  @Input() currentSelection: { selectedArea: any[]; selectedPref?: any[]; selectedStores: any[] } = {
    selectedArea: [],
    selectedStores: [],
  };
  @Output() presetLoaded = new EventEmitter<StorePreset>();

  visible = false;
  presetName = '';
  presets: StorePreset[] = [];

  constructor(private presetService: StorePresetService) {}

  open() {
    this.presets = this.presetService.getPresets(this.componentName);
    this.presetName = '';
    this.visible = true;
  }

  get canSave(): boolean {
    return this.presetName.trim().length > 0 && this.presetService.canSaveMore(this.componentName);
  }

  get isAtLimit(): boolean {
    return !this.presetService.canSaveMore(this.componentName);
  }

  save() {
    if (!this.canSave) return;
    this.presetService.savePreset(this.componentName, {
      name: this.presetName.trim(),
      selectedArea: this.currentSelection.selectedArea,
      selectedPref: this.currentSelection.selectedPref,
      selectedStores: this.currentSelection.selectedStores,
    });
    this.presets = this.presetService.getPresets(this.componentName);
    this.presetName = '';
  }

  load(preset: StorePreset) {
    this.presetLoaded.emit(preset);
    this.visible = false;
  }

  delete(presetId: string) {
    this.presetService.deletePreset(this.componentName, presetId);
    this.presets = this.presetService.getPresets(this.componentName);
  }
}
